import { useFormContext, Controller } from "react-hook-form";
import { TextField } from "@mui/material";
import { useRef } from "react";

type Props = {
  name: string;
  label?: string;
};

export default function RHFTimeInput({ name, label }: Props) {
  const { control } = useFormContext();
  const isBackspaceRef = useRef(false);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          label={label}
          fullWidth
          error={!!error}
          helperText={error?.message}
          placeholder="00:00"
          inputProps={{
            maxLength: 5,
            inputMode: "numeric",
            pattern: "([01][0-9]|2[0-3]):[0-5][0-9]",
          }}
          onKeyDown={(e) => {
            isBackspaceRef.current = e.key === "Backspace";
          }}
          onChange={(e) => {
            let value = e.target.value.replace(/[^0-9]/g, "");

            // se digitou 2 números e não tá apagando, adiciona ":" só se não for backspace
            if (value.length > 2 && !isBackspaceRef.current) {
              value = value.slice(0, 2) + ":" + value.slice(2);
            } else if (value.length > 2) {
              value = value.slice(0, 5); // limita a 5 caracteres
            }

            field.onChange(value);
          }}
        />
      )}
    />
  );
}
